import * as FaIconsBrands from '@fortawesome/free-brands-svg-icons'
import * as FaIconsRegular from '@fortawesome/pro-regular-svg-icons'
import * as FaIconsSolid from '@fortawesome/pro-solid-svg-icons'

import { Suffix } from '../../../types'

import CustomIcons from './customIcons'
export type FontAwesomeIconKeyRegular = keyof typeof FaIconsRegular
export type FontAwesomeIconKeyBrand = keyof typeof FaIconsBrands
export type FontAwesomeIconKey = FontAwesomeIconKeyRegular | FontAwesomeIconKeyBrand
export type FontAwesomeIconKeyCapitalized = `F${Suffix<FontAwesomeIconKey, 'f'>}` // fa* Icon names with capitalized F
export type FontAwesomeIconKeySolid = keyof typeof FaIconsSolid
export type FontAwesomeIconKeySolidCapitalized = `Fa${Suffix<FontAwesomeIconKeySolid, 'fa'>}Solid` // faa* Icon names with capitalized F
export type FontAwesomeIconKeyBrandCapitalized = `F${Suffix<FontAwesomeIconKeyBrand, 'f'>}`

export type CustomIconKey = keyof typeof CustomIcons

export type IconProps = {
  className?: string
  icon: IconKey
}
export type IconKey =
  | CustomIconKey
  | FontAwesomeIconKeyCapitalized
  | FontAwesomeIconKeySolidCapitalized
  | FontAwesomeIconKeyBrandCapitalized // In the future, can extend this with other icon key sets, either our own in-house icons or other libraries

// This is a list of keys that are not valid FontAwesome icons
const ExtraneousKeys = ['far', 'fab', 'prefix']

const FontAwesomeRegularKeys = Object.keys(FaIconsRegular).filter(
  (k) => !ExtraneousKeys.includes(k)
) as FontAwesomeIconKeyRegular[]

const FontAwesomeBrandKeys = Object.keys(FaIconsBrands).filter(
  (k) => !ExtraneousKeys.includes(k)
) as FontAwesomeIconKeyBrand[]

const FontAwesomeSolidKeys = Object.keys(FaIconsSolid).filter(
  (k) => !ExtraneousKeys.includes(k)
) as FontAwesomeIconKeySolid[]

export const FontAwesomeIconKeys = [
  ...new Set([...FontAwesomeRegularKeys, ...FontAwesomeBrandKeys, ...FontAwesomeSolidKeys]),
] as FontAwesomeIconKey[]
export const FontAwesomeIconKeysRegular = FontAwesomeRegularKeys
export const FontAwesomeIconKeysBrand = FontAwesomeBrandKeys
export const FontAwesomeIconKeysSolid = Object.keys(FaIconsSolid).filter(
  (k) => !ExtraneousKeys.includes(k)
) as FontAwesomeIconKeySolid[]

export const getIconKeyFromString = (key: FontAwesomeIconKey): FontAwesomeIconKeyCapitalized => {
  return `F${key.substring(1)}` as FontAwesomeIconKeyCapitalized
}
